/**
 * Mirrors apps/merchant-dashboard's own `features/products/format-price.ts`
 * (`formatCatalogPrice`) exactly — `orders.grand_total` is a TND amount
 * DIRECTLY (`numeric(12,3)`), not a millime count, the same convention
 * that file documents at length. `gmv` (platform-wide) is a sum of that
 * same column, so the identical formatter applies unchanged.
 */
export function formatTnd(amountTnd: number): string {
  if (!Number.isFinite(amountTnd)) {
    throw new RangeError(`formatTnd received a non-finite amount: ${String(amountTnd)}`);
  }

  return new Intl.NumberFormat('fr-TN', {
    style: 'currency',
    currency: 'TND',
    minimumFractionDigits: 3,
    maximumFractionDigits: 3,
  }).format(amountTnd);
}
